import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAuthInterceptor } from "./util";

export const rejectedDriverDocmentApi = createApi({
  reducerPath: "rejectedDriverDocmentApi",
  baseQuery: baseQueryWithAuthInterceptor({ baseUrl: "/api" }),
  tagTypes: ["RejectedDriverDocument"],
  endpoints: (builder) => ({
    documentApproval: builder.mutation({
      query: (body) => ({
        url: "/document-approval",
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) => !error && ["RejectedDriverDocument"],
    }),
  }),
});

export const { useDocumentApprovalMutation } = rejectedDriverDocmentApi;